import { createSvgIcon } from './utils';

export default createSvgIcon(
  <path d="M12.0093059,8.96 L4.20014024,1.15437526 C3.93610299,0.890457732 3.93610299,0.46185567 4.20014024,0.197938144 C4.46417749,-0.0659793814 4.89297398,-0.0659793814 5.15701123,0.197938144 L13.441444,8.47861443 C13.5745188,8.61162887 13.64,8.78475876 13.64,8.96 C13.64,9.1331299 13.5745188,9.30837113 13.441444,9.44138557 L5.15489893,17.7220619 C4.89086168,17.9859794 4.46206519,17.9859794 4.19802794,17.7220619 C3.93399069,17.4581443 3.93399069,17.0295423 4.19802794,16.7656247 L12.0093059,8.96 Z" />,
  'Right',
  '0 0 24 24'
);
